import Vue from 'vue'
import VueRouter from 'vue-router'


import Login from '../views/login'
import Empty from '../views/login/empty'
import Start from '../views/start'
import Rule from '../views/start/rule'
import Notice from '../views/start/notice'


import Layout from '../views/layout'

//感受（滑块1、2、3、4、5、6）
import Feel from '../views/feel'
import FeelSection from '../views/feel/section'
//攻击性问题3、4和天气问题5、6、7（单选）
import AggressionWeather from '../views/aggression_weather'
import WeatherSection from '../views/aggression_weather/section'

//位置题目
import Location1 from '../views/location/step1'
//室内选项
import Location2 from '../views/location/step2'
//室外选项
import Location3 from '../views/location/step3'
import Garden from '../views/location/step3_garden'
import Enter1 from '../views/location/garden_enter1'
import Enter2 from '../views/location/garden_enter2'
import Enter3 from '../views/location/garden_enter3'
import Enter4 from '../views/location/garden_enter4'
import Enter5 from '../views/location/garden_enter5'
import Leave1 from '../views/location/garden_leave1'
//位置题目（和谁在一起）
import Location4 from '../views/location/step4'
//自然环境问题（单选）
import Nature1 from '../views/nature/nature1'
import Nature11 from '../views/nature/nature1_1'
import Nature2 from '../views/nature/nature2'
import Nature21 from '../views/nature/nature2_1'
import Nature22 from '../views/nature/nature2_2'
import Nature3 from '../views/nature/nature3'

// 城市环境题目
import Building from '../views/urban_elements/building.vue'
import Shop from '../views/urban_elements/shop'
import Street from '../views/urban_elements/street'

//拍照题
import Photo from '../views/photo'
import Audio from '../views/audio/index'
import Advice from '../views/advice'

// 当日第一次做任务
import Task from '../views/endPage/task'
// 当日第二次做任务评价
import TaskEvaluation from '../views/endPage/task_evaluation'
import TaskEvaluationFinished from '../views/endPage/task_evaluation_finished'
import TaskEvaluationUnfinished from '../views/endPage/task_evaluation_unfinished'
// 结束页面
import End from '../views/endPage'
import Statistics from '../views/endPage/statistics'

Vue.use(VueRouter)

//解决重复点击路由报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            title: 'ema',
            keepAlive: false
        }
    },
    {
        path: '/empty',
        name: 'empty',
        component: Empty,
        meta: {
            title: 'ema',
            keepAlive: false
        }
    },
    {
        path: '/start',
        name: 'start',
        component: Start,
        meta: {
            title: 'QuesFill',
            keepAlive: false
        }
    },
    {
        path: '/rule',
        name: 'rule',
        component: Rule,
        meta: {
            title: 'QuesFill',
            keepAlive: false
        }
    },
    {
        path: '/notice',
        name: 'notice',
        component: Notice,
        meta: {
            title: 'QuesFill',
            keepAlive: false
        }
    },
    {
        path: '/task_evaluation',
        name: 'task_evaluation',
        component: TaskEvaluation,
        meta: {
            title: 'QuesFill',
            keepAlive: false
        }
    },
    {
        path: '/task_evaluation_finished',
        name: 'task_evaluation_finished',
        component: TaskEvaluationFinished,
        meta: {
            title: 'QuesFill',
            keepAlive: false
        }
    },
    {
        path: '/task_evaluation_unfinished',
        name: 'task_evaluation_unfinished',
        component: TaskEvaluationUnfinished,
        meta: {
            title: 'QuesFill',
            keepAlive: false
        }
    },
    {
        path: '/layout',
        name: 'layout',
        component: Layout,
        children: [
            {
                path: '/mental',
                redirect: '/mental/a',
                component: Feel,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                },
                children: [
                    {
                        path: 'a',
                        name: 'c',
                        component: FeelSection
                    }
                ]
            },
            {
                path: '/aggression_weather',
                redirect: '/aggression_weather/a',
                component: AggressionWeather,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                },
                children: [
                    {
                        path: 'a',
                        name: 'd',
                        component: WeatherSection
                    }
                ]
            },
            {
                path: '/location1',
                name: 'location1',
                component: Location1,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/location2',
                name: 'location2',
                component: Location2,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/location3',
                name: 'location3',
                component: Location3,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/garden',
                name: 'garden',
                component: Garden,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/enter1',
                name: 'enter1',
                component: Enter1,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/enter2',
                name: 'enter2',
                component: Enter2,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/enter3',
                name: 'enter3',
                component: Enter3,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/enter4',
                name: 'enter4',
                component: Enter4,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/enter5',
                name: 'enter5',
                component: Enter5,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/leave1',
                name: 'leave1',
                component: Leave1,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/location4',
                name: 'location4',
                component: Location4,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/nature1',
                name: 'nature1',
                component: Nature1,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/nature1_1',
                name: 'nature1_1',
                component: Nature11,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/nature2',
                name: 'nature2',
                component: Nature2,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/nature2_1',
                name: 'nature2_1',
                component: Nature21,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/nature2_2',
                name: 'nature2_2',
                component: Nature22,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/nature3',
                name: 'nature3',
                component: Nature3,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/building',
                name: 'building',
                component: Building,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/shop',
                name: 'shop',
                component: Shop,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/street',
                name: 'street',
                component: Street,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/photo',
                name: 'photo',
                component: Photo,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/audio',
                name: 'audio',
                component: Audio,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/advice',
                name: 'advice',
                component: Advice,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/task',
                name: 'task',
                component: Task,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            },
            {
                path: '/end',
                name: 'end',
                component: End,
                meta: {
                    title: 'QuesFill',
                    keepAlive: false
                }
            }
        ]
    },
    {
        path: '/statistics',
        name: 'statistics',
        component: Statistics,
        meta: {
            title: 'statisticResult',
            keepAlive: false
        }
    },
    {
        path: '*', // 通用路由
        redirect: '/start'
    }
]

const router = new VueRouter({
    // base:'quzhou',
    mode: 'history',
    routes
})

export default router
